<div class='outer'>
  <div class='left'>
  </div>
  <div class='right'>
    <div class='content'>
      <div class='logo' *ngIf='logoVisible()'>
          <img src="assets/imgs/music-together-logo.png">
          <img class='teachers-only' src="assets/imgs/for-teachers-only.png">
      </div>
      <div class='invalid-login' *ngIf='invalidLogin'>
        <h2>Uh Oh!</h2>
        <p>It doesn't look like your email or password were correct. Please try again!</p>
      </div>
      <div class='center'>
        <div class='name-password'>
          <label class="input-label">Username</label>
          <input name="username" placeholder='eg. maryslamb@gmail.com' (keydown)='resetLogin()' (keydown.enter)='loginUser()' [(ngModel)]='username'>
          <label class="input-label">Password</label>
          <input type="password" placeholder='Password' (keydown)='resetLogin()' (keydown.enter)='loginUser()' secure [(ngModel)]='password'>
          <div class='actions'>
            <button class='login' block [disabled]='waitingToLogin' (click)='loginUser()'>Login</button>
            <ion-spinner class='waiting' name='circles' *ngIf='waitingToLogin'></ion-spinner>
            <button class='forgot-password' (click)='forgotPassword()'>Forgot Your Password?</button>
          </div>
        </div>
      </div>
      <div class='training' *ngIf="trainingVisible()">
        <h2>Not a Music Together Teacher?</h2>
        <button (click)='findTrainingCenter()'>Find a Training Near You!</button>      
      </div>
      <div class='friends' *ngIf="friendsVisible()">
          <img src='assets/friends/Friends-login1.gif'>
          <img src='assets/friends/Friends-login2.gif'>
      </div>
    </div>
  </div>
</div>
